import React from "react";
import PricingDesktop from "./PricingDesktop";
import PageLayout from "../PageLayout/PageLayout";

export default function PricingPage() {
  return (
    <PageLayout>
      <PricingDesktop />
    </PageLayout>
  );
}
